export default "__VITE_ASSET__DQnatbs___"